import { StatusBannerSeverity, StatusBannerSurface, StatusBannerType } from "api/rpc/2024-04/masterAdmin/statusBanner";

export const STATUS_BANNER_TYPE_OPTIONS: Array<{ id: StatusBannerType; label: string }> = [
  { id: "outage", label: "Outage" },
  { id: "maintenance", label: "Maintenance" },
  { id: "degradation", label: "Degradation" },
  { id: "info", label: "Info" },
];

export const STATUS_BANNER_SEVERITY_OPTIONS: Array<{ id: StatusBannerSeverity; label: string }> = [
  { id: "info", label: "Info" },
  { id: "warning", label: "Warning" },
  { id: "critical", label: "Critical" },
];

export const STATUS_BANNER_SURFACE_GROUPS: Array<{
  label: string;
  surfaces: Array<{ id: StatusBannerSurface; label: string }>;
}> = [
  {
    label: "Tee-On Admin",
    surfaces: [
      { id: "facility_admin", label: "Facility Admin" },
      { id: "client_admin", label: "Client Admin" },
      { id: "master_admin", label: "Master Admin" },
    ],
  },
  {
    label: "Guest",
    surfaces: [
      { id: "customer_portal", label: "Customer Portal" },
      { id: "tee_on_portal", label: "Tee-On Portal" },
      { id: "online_store", label: "Online Store" },
      { id: "guest", label: "Other guest pages" },
    ],
  },
  {
    label: "Other apps",
    surfaces: [
      { id: "billing", label: "Billing" },
      { id: "scoring", label: "Scoring" },
    ],
  },
];

export const STATUS_BANNER_SURFACE_LABELS: Record<StatusBannerSurface, string> = {
  facility_admin: "Facility Admin",
  client_admin: "Client Admin",
  master_admin: "Master Admin",
  customer_portal: "Customer Portal",
  tee_on_portal: "Tee-On Portal",
  online_store: "Online Store",
  guest: "Guest pages",
  billing: "Billing",
  scoring: "Scoring",
};

export function statusBannerTypeLabel(type: StatusBannerType): string {
  return STATUS_BANNER_TYPE_OPTIONS.find(option => option.id === type)?.label ?? type;
}

export function toDatetimeLocalValue(iso: string | null | undefined): string {
  if (!iso) {
    return "";
  }
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return "";
  }
  const pad = (value: number) => String(value).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function fromDatetimeLocalValue(value: string): string | null {
  if (!value) {
    return null;
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  return date.toISOString();
}
